<div
  id="scroll-container"
  class="flex overflow-x-auto mt-8"
>
  <p-breadcrumb [model]="items">
    <ng-template
      pTemplate="item"
      let-item
    >
      <ng-container *ngIf="item.route; else elseBlock">
        <a
          [routerLink]="item.route"
          class="p-menuitem-link"
          style="width: max-content"
        >
          <span
            class="breadcrumb item"
            [innerHTML]="item.label"
          ></span>
        </a>
      </ng-container>
      <ng-template #elseBlock>
        <a
          [href]="item.url"
          style="width: max-content"
        >
          <span
            class="breadcrumb item"
            [innerHTML]="item.label"
          ></span>
        </a>
      </ng-template>
    </ng-template>
    <ng-template
      pTemplate="separator"
      let-separator
    >
      <i class="pi pi-chevron-right breadcrumb separator mt-1"></i>
    </ng-template>
  </p-breadcrumb>
</div>
